import {Action} from '@ngrx/store';
import {BijbEvent} from '../../../models/bijb-event';

export class GetUsersAction implements Action {
  public static readonly type = 'GetUsersAction';

  constructor(public bijbEvent: BijbEvent) {
  }

  public type = GetUsersAction.type;
}
